module.exports = __webpack_public_path__ + "img/mi-work.fcf93e9a.svg";